import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledFooter = styled.footer`
  margin: 0;
  margin-top: 5rem;
  padding: 0 0 2rem;
  color: white;
  background: #3c2312;
  grid-row: 2/3;

  a {
    color: white;
    text-decoration: underline;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: ${theme.colors.tertiaryHover};
    }
  }

  p {
    margin: 0;
    text-align: center;
  }

  .association-logos {
    background: ${theme.colors.tertiary};
    text-align: center;
    padding: 5rem;
    margin-block-end: 2rem;
    section.logos {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 5rem;

      @media (max-width: ${theme.breakpoints[0]}) {
        display: block;
        text-align: center;

        a {
          width: 100%;
          margin: 2rem;
        }
      }
    }
  }
`

export default StyledFooter
